import { forwardRef, HTMLAttributes } from 'react'
import { Slot } from '@radix-ui/react-slot'
import { cva, VariantProps } from 'class-variance-authority'
import parse from 'html-react-parser'

import { nl2br, removeParagraph } from '@/utils'

import { cn } from '@/lib/utils'

const typographyVariants = cva('', {
  variants: {
    variant: {
      base: '',
      small: 'font-helvetica text-small',
      'upper-small': 'font-helvetica text-upper-small',
      'main-title-default': 'font-helvetica text-main-title-default',
      breadcrumbs: 'font-helvetica text-breadcrumbs',
      button: 'font-helvetica text-button',
      standard: 'font-helvetica text-s-standard md:text-d-standard',
      'medium-upper': 'font-helvetica text-medium-upper',
      'big-quote': 'font-helveticanow text-s-big-quote md:text-m-big-quote xl:text-d-big-quote',
      'big-100': 'font-helvetica text-s-big-100 md:text-d-big-100',
      'hero-tb-customized': 'font-helvetica text-s-hero-tb-customized md:text-d-hero-tb-customized',
      'history-size-body': 'font-helvetica text-history-size-body'
    }
  },
  defaultVariants: {
    variant: 'base'
  }
})

const childrenClasses = cn([''])

export type TypographyProps = HTMLAttributes<HTMLElement> &
  VariantProps<typeof typographyVariants> &
  Partial<{
    component: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span'
    paragraph: boolean
    asChild: boolean
  }>

const Typography = forwardRef<HTMLElement, TypographyProps>(
  (
    {
      variant,
      className,
      children,
      component = false,
      paragraph = false,
      asChild = false,
      ...props
    },
    ref
  ) => {
    const Component = asChild ? Slot : ((component || (paragraph ? 'p' : 'span')) as any)

    return (
      <Component
        className={cn(typographyVariants({ variant, className }), childrenClasses)}
        ref={ref}
        {...props}
      >
        {parse(children ? removeParagraph(nl2br(children as string)) : '')}
      </Component>
    )
  }
)

export default Typography
